<template>
  <div>
    <base-confirm
      v-if="visible"
      @close="$emit('close')"
      @confirmed="onConfirmed"
      size="max-w-xl"
      message="Faktur Penjualan yang lama akan dihapus dan diganti faktur yang baru. Apakah anda yakin?"
      type="danger"
      icon-type="badge"
      title="Edit Faktur Penjualan"
      confirm-text="Ya"
      cancel-text="Tutup"
      visible
    />
    <loading v-if="loading" />
  </div>
</template>

<script>
import BaseConfirm from '@/components/base/BaseConfirm.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  components: { BaseConfirm },
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    orderId: String,
  },
  emits: ['close', 'confirmed'],
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async onConfirmed() {
      this.loading = true;

      const [, err] = await this.request(
        `/api/v1/orders/${this.orderId}/-actions/duplicate`,
        {
          method: 'post',
        }
      );

      if (err) {
        this.createAlert({
          data: this.getRequestErrorMessage(err),
          status: 'error',
        });
      } else {
        this.$emit('confirmed');
      }

      this.loading = false;
    },
  },
};
</script>
